import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from '../ui/CountdownTimer';
import { CTAButton } from '../ui/CTAButton';
import { BookIcon, GiftIcon, UsersIcon, CertificateIcon, ClockIcon } from '../icons/SalesIcons';
export function HeroSection() {
  const trustBadges = [{
    icon: BookIcon,
    text: '21 Módulos'
  }, {
    icon: GiftIcon,
    text: '8 Bonos Incluidos'
  }, {
    icon: UsersIcon,
    text: 'Comunidad Privada'
  }, {
    icon: CertificateIcon,
    text: 'Certificado'
  }];
  return <section id="hero-section" className="relative bg-[#FDF8F4] overflow-hidden" data-id="element-217">
      {/* Urgency Bar */}
      <div className="bg-gradient-to-r from-[#9B2335] to-[#7a1c2a] text-white py-3 px-4" data-id="element-218">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6" data-id="element-219">
          <div className="flex items-center gap-2" data-id="element-220">
            <ClockIcon size={20} className="text-[#C4A882]" data-id="element-221" />
            <span className="text-sm md:text-base font-medium uppercase tracking-wide" data-id="element-222">
              Oferta de Lanzamiento — Precio Especial por Tiempo Limitado
            </span>
          </div>
          <CountdownTimer data-id="element-223" />
        </div>
      </div>

      {/* Main Hero Content */}
      <div className="max-w-7xl mx-auto px-4 py-12 md:py-20" data-id="element-224">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-225">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="text-center lg:text-left" data-id="element-226">
            {/* Brand Name */}
            <div className="mb-6" data-id="element-227">
              <h2 className="font-script text-4xl md:text-6xl text-[#C4A882] mb-2" data-id="element-228">
                Ilumina y Crea
              </h2>
              <p className="font-script text-xl text-[#9B2335]" data-id="element-229">
                Velas Artesanales con tus Manos
              </p>
            </div>

            {/* Main Headline */}
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#5C4033] leading-tight mb-6" data-id="element-230">
              Deja de desperdiciar cera y dinero: aprende la fórmula exacta que
              usan las veleras profesionales
            </h1>

            {/* Subheadline */}
            <p className="text-lg md:text-xl text-[#2D2926] mb-8 leading-relaxed" data-id="element-231">
              El sistema completo de 21 módulos que te lleva de cero a crear y
              vender velas artesanales profesionales — desde tu casa
            </p>

            {/* Pricing */}
            <div className="mb-6 flex flex-col items-center lg:items-start gap-2" data-id="element-232">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#9B2335] text-white text-sm font-bold rounded-full uppercase tracking-wide" data-id="element-233">
                <ClockIcon size={14} className="text-[#C4A882]" data-id="element-234" />
                25% de descuento — Tiempo limitado
              </div>
              <div className="flex items-baseline gap-3" data-id="element-235">
                <span className="text-lg text-[#5C4033]/50 line-through" data-id="element-236">
                  $69 USD
                </span>
                <span className="font-heading text-4xl md:text-5xl text-[#9B2335] font-bold" data-id="element-237">
                  $52.49 USD
                </span>
              </div>
              <p className="text-sm text-[#5C4033]/70" data-id="element-238">
                Pago único — Acceso de por vida
              </p>
            </div>

            {/* CTA Button */}
            <div className="mb-8" data-id="element-239">
              <CTAButton text="Sí, Quiero Encender Mi Llama — Acceder Ahora" fullWidth className="lg:w-auto" data-id="element-240" />
            </div>

            {/* Trust Badges */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-241">
              {trustBadges.map((badge, index) => <motion.div key={badge.text} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.2 + index * 0.1
            }} className="flex flex-col items-center gap-2 p-3 bg-white/50 rounded-lg border border-[#C4A882]/30" data-id="element-242">
                  <badge.icon size={24} className="text-[#9B2335]" data-id="element-243" />
                  <span className="text-sm font-medium text-[#5C4033] text-center" data-id="element-244">
                    {badge.text}
                  </span>
                </motion.div>)}
            </div>
          </motion.div>

          {/* Right Content - Hero Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-245">
            <div className="relative" data-id="element-246">
              {/* Decorative glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#C4A882]/20 to-[#9B2335]/10 rounded-3xl blur-3xl" data-id="element-247" />

              {/* Main Image */}
              <img src="https://cdn.magicpatterns.com/uploads/pFuqYVnB8YN26xHHnZL6va/mk-1.png" alt="Curso Ilumina y Crea - Vista previa del curso de velas artesanales" className="relative w-full h-auto rounded-2xl shadow-2xl" data-id="element-248" />

              {/* Floating badge */}
              <motion.div animate={{
              y: [0, -10, 0]
            }} transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="absolute -bottom-4 -right-4 md:bottom-8 md:right-8 bg-[#9B2335] text-white px-4 py-2 rounded-full shadow-lg" data-id="element-249">
                <span className="font-bold" data-id="element-250">+1000 Alumnas</span>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#D4A0A0]/10 to-transparent pointer-events-none" data-id="element-251" />
      <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-tr from-[#C4A882]/5 to-transparent pointer-events-none" data-id="element-252" />
    </section>;
}